<template>
  <div class="container teachers">
    <com-title title="企业赋能顾问"></com-title>
    <div class="parentBox">
      <ul class="columns is-mobile">
        <li class="column is-one-third-tablet is-one-quarter-desktop" v-for="(item, index) in teachers" :key="index">
          <div class="wrap">
            <a herf="javascript:void(0)">
                <div class="img">
                  <img :src="item.img" alt="">
                </div>
                <div class="content">
                  <p class="name">{{item.name}}</p>
                  <!-- <p class="company">{{item.company}}</p> -->
                  <!-- <div class="focus">{{item.company}}{{item.focus}}</div> -->
                  <p class="brief">{{item.company}}，{{item.brief}}<br><br>{{item.focus}}</p>
                </div>
            </a>
          </div>
        </li>
      </ul>
    </div>
    <p class="tips">更多技术专家讲师资源请垂询企业培训服务顾问</p>
  </div>
</template>
<script>
import comTitle from '@/base/title'
import IScroll from 'iscroll'
import teachers from '@/util/teachers'
export default {
  data () {
    return {
      ...teachers
    }
  },
  components: {
    comTitle
  },
  computed: {},
  methods: {
    iscrollLeft () {
      return new IScroll('.parentBox', {
        scrollX: true,
        scrollY: false,
        // scrollbars: true,  // 滚动槽
        eventPassthrough: true
      })
    }
  },
  mounted () {
    this.iscrollLeft()
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/variable.sass'

+mobile
  .container
    width: 88vw

div.teachers
  border-bottom: 1px solid #e8e8e8
  .parentBox
    +mobile
      height: 22rem
    .iScrollLoneScrollbar
      width: 96vw
      bottom: 10px
    .columns
      flex-wrap: wrap
      margin-top: 0.4rem
      +mobile
        flex-wrap: nowrap
        width: 2508px
      li.column
        border-radius: 5px
        padding: 0.88rem
        transition: .3s all linear
        width: 20%
        +mobile
          width: 501.6px
        &:hover
          .wrap
            div.brief
              top: 0
        +tablet-only
          width: 33.33%
          &:nth-child(n+7)
            display: none
        .wrap
          // position: relative
          // overflow: hidden
          a
            background-color: #fff
            display: flex
            align-items: center
            justify-content: center
            flex-direction: column
            width: 100%
            height: 100%
            padding: 0.9rem
            transition: all 0.3s
            box-shadow: 0px 4px 15px 0px rgba(7, 17, 27, 0.1)
            cursor: auto
            .img
              width: 75%
              margin: 20px 0 10px
              text-align: center
            .content
              text-align: center
              margin-bottom: 20px
              p.name
                font-weight: 700
                margin-bottom: 2%
              p.company
                font-size: 12px
                color: #888
              div.focus
                font-size: 12px
                color: #888
              p.brief
                // position: absolute
                text-align: justify
                font-size: 12px
                margin-top: 10px
                +limit-line-numbers(6)
                // background-color: rgba(255,90,5,0.9)

  p.tips
    text-align: center
    margin: 0 auto
    margin-top: 40px
    margin-bottom: 40px
</style>
